import {
  Address,
  ToolkitProperty,
  ToolkitPropertyRowMap,
  addressToString,
  dynamicScalarToString,
  isDynamicScalar,
} from '@aloft/toolkit-shared';

import { PLACEHOLDER } from '../constants.js';
import { systemAccessorTPColumnDefs } from '../systemAccessorTPColumnDefs.js';
import {
  SystemAccessorTPColumnKey,
  TPColumnKey,
  isSystemAccessorTPColumnKey,
  isTPColumnKey,
} from '../types.ts';

export function getToString(
  column: TPColumnKey | SystemAccessorTPColumnKey,
  subjectProperty: ToolkitProperty | undefined,
): (value: unknown) => string {
  return (value: unknown) => {
    if (value === undefined) return PLACEHOLDER;
    if (typeof value === 'string') return value;

    if (isSystemAccessorTPColumnKey(column)) {
      return systemAccessorTPColumnDefs[column].toString(value as any, subjectProperty); // TODO: Fix this `any`
    }
    if (isTPColumnKey(column)) {
      const info = ToolkitPropertyRowMap[column];
      if (info.type === 'address') {
        const address: Address = value as Address;
        return addressToString(address);
      }
      return (isDynamicScalar(value) ? dynamicScalarToString(value) : null) ?? PLACEHOLDER;
    }

    console.error(`Invalid column '${column}'.`);
    return '';
  };
}
